module.exports = "img/info-slide-2.3202f6.jpeg";